export default __webpack_public_path__ + "static/media/Nosferatu.a354bf8c.mp3";